import { render, staticRenderFns } from "./PersonArrow.vue?vue&type=template&id=dad8868e&scoped=true&"
import script from "./PersonArrow.vue?vue&type=script&lang=js&"
export * from "./PersonArrow.vue?vue&type=script&lang=js&"
import style0 from "./PersonArrow.vue?vue&type=style&index=0&id=dad8868e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad8868e",
  null
  
)

export default component.exports